module.exports = __webpack_public_path__ + "static/media/paris_florist_getty_mobile.984fe3f0.jpg";